import type { FaireProductEntity } from "../../entity_types/product";

export const p_7y25fg3635: FaireProductEntity = {
  token: "p_7y25fg3635",
  type: "product",
  name: "Chirps and Cheers Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/09f06c0c185623fd80140c521bb674397f0e6e0fb97dca533ff7479ef64c649e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b9983caa258734cf853ff0dcdf66edaa3cdafb2f6dad476fb897ef6079853616.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "So this is what birders are actually searching for with all the binoculars? Teeny wine glasses?! Clever birds - no wonder they're so elusive. They're sipping!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:38.897Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
